export default "__VITE_ASSET__CJMrgiFw__"